const API_BASE_URLS = ['/api', 'www.registo.ucm.ac.mz/api'];

// Inicializa currentBaseUrlIndex a partir do localStorage, ou 0 se não existir
let currentBaseUrlIndex = parseInt(localStorage.getItem('apiBaseUrlIndex') || '0', 10);
// Garante que o índice seja válido, caso a lista de URLs mude ou o valor no localStorage seja inválido
if (currentBaseUrlIndex < 0 || currentBaseUrlIndex >= API_BASE_URLS.length) {
    currentBaseUrlIndex = 0;
    localStorage.setItem('apiBaseUrlIndex', currentBaseUrlIndex); // Salva o valor padrão
}

const MAX_RETRIES = API_BASE_URLS.length; // Tenta cada URL uma vez

// Função para obter a URL base da API (sem o /api)
export const getBaseUrl = () => {
    const currentApiUrl = API_BASE_URLS[currentBaseUrlIndex];
    // Remove o '/api' do final para obter a base (ex: http://localhost:8080)
    return currentApiUrl.replace('/api', '');
};

// NOVO: Função para obter a URL base COMPLETA da API (incluindo /api)
export const getFullApiBaseUrl = () => {
    return API_BASE_URLS[currentBaseUrlIndex];
};

// Função auxiliar para realizar as chamadas fetch
async function request(endpoint, options = {}, retryCount = 0) {
    const baseUrl = API_BASE_URLS[currentBaseUrlIndex];
    const url = `${baseUrl}${endpoint}`;
    
    const { body, responseType, isFormData, ...customConfig } = options; // Adicionado isFormData

    const headers = {};
    
    // Se não for FormData, define Content-Type como application/json
    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }

    const token = localStorage.getItem('jwtToken');
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    };

    if (body && !isFormData) {
        config.body = JSON.stringify(body);
    } else if (body && isFormData) {
        config.body = body;
        // Não defina Content-Type para FormData, o navegador faz isso automaticamente
        delete config.headers['Content-Type'];
    }

    try {
        const response = await fetch(url, config);

        if (!response.ok) {
            // Se for um erro de servidor (5xx) ou se o status for 0 (geralmente erro de rede/CORS antes de receber resposta HTTP)
            // e ainda houver tentativas, tenta o próximo URL.
            if ((response.status >= 500 || response.status === 0) && retryCount < MAX_RETRIES - 1) {
                console.warn(`API call to ${baseUrl} failed with status ${response.status}. Retrying with next URL.`);
                currentBaseUrlIndex = (currentBaseUrlIndex + 1) % API_BASE_URLS.length;
                localStorage.setItem('apiBaseUrlIndex', currentBaseUrlIndex); // Salva o novo índice no localStorage
                return request(endpoint, options, retryCount + 1); // Tenta novamente com o próximo URL
            }
            // Para outros erros (e.g., 4xx) ou se não houver mais tentativas, lança o erro
            const errorText = await response.text();
            try {
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.message || errorText);
            } catch (e) {
                throw new Error(errorText || `HTTP error! status: ${response.status}`);
            }
        }
        
        // Se a requisição foi bem-sucedida, garante que este URL seja priorizado para futuras chamadas
        // e armazena no localStorage
        const successfulIndex = API_BASE_URLS.indexOf(baseUrl);
        if (currentBaseUrlIndex !== successfulIndex) {
            currentBaseUrlIndex = successfulIndex;
            localStorage.setItem('apiBaseUrlIndex', currentBaseUrlIndex);
        }

        if (responseType === 'blob') {
            return response.blob();
        }

        if (response.status === 204 || response.headers.get('Content-Length') === '0') {
            return true;
        }

        return response.json();
    } catch (error) {
        // Captura erros de rede (e.g., 'Failed to fetch') que não resultam em uma resposta HTTP
        if (error.message.includes('Failed to fetch') && retryCount < MAX_RETRIES - 1) {
            console.warn(`API call to ${baseUrl} failed (network error). Retrying with next URL.`);
            currentBaseUrlIndex = (currentBaseUrlIndex + 1) % API_BASE_URLS.length;
            localStorage.setItem('apiBaseUrlIndex', currentBaseUrlIndex); // Salva o novo índice no localStorage
            return request(endpoint, options, retryCount + 1); // Tenta novamente com o próximo URL
        }
        console.error('API call failed for endpoint:', endpoint);
        throw error;
    }
}

// --- Auth ---
export const loginUser = (credentials) => request('/auth/login', { method: 'POST', body: credentials });
export const registerUser = (userData) => request('/participantes/registrar', { method: 'POST', body: userData });
export const forgotPassword = (email) => request('/participantes/forgot-password', { method: 'POST', body: { email } });
export const resetPassword = (token, newPassword) => request('/participantes/reset-password', { method: 'POST', body: { token, newPassword } });

// --- Participantes ---
export const getUserProfile = () => request('/participantes/perfil'); // Endpoint para perfil do usuário logado
export const updateUserProfile = (id, userData) => request(`/participantes/${id}`, { method: 'PUT', body: userData }); // CORRIGIDO: Atualizar perfil do usuário logado usando ID

// --- Eventos ---
export const getEventos = () => request('/eventos');
export const getAdminEventos = () => request('/eventos/admin');
export const getEventoById = (id) => request(`/eventos/${id}`);
export const createEvento = (eventoData) => request('/eventos', { method: 'POST', body: eventoData });
export const updateEvento = (id, eventoData) => request(`/eventos/${id}`, { method: 'PUT', body: eventoData });
export const ativarEvento = (id) => request(`/eventos/${id}/ativar`, { method: 'PUT' });
export const desativarEvento = (id) => request(`/eventos/${id}/desativar`, { method: 'PUT' });
export const deleteEvento = (id) => request(`/eventos/${id}`, { method: 'DELETE' });
export const desativarEventosFinalizados = () => request('/eventos/desativar-finalizados', { method: 'POST' });

// NOVO: Imagem do Evento
export const uploadEventoImage = (eventoId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const endpoint = eventoId ? `/eventos/${eventoId}/upload-imagem` : '/eventos/upload-imagem';
    return request(endpoint, { method: 'POST', body: formData, isFormData: true });
};
export const deleteEventoImage = (eventoId) => request(`/eventos/${eventoId}/delete-imagem`, { method: 'DELETE' });

// --- Sessões ---
export const getSessoesByEvento = (eventoId) => request(`/sessoes/evento/${eventoId}`);
export const createSessao = (sessaoData) => request('/sessoes', { method: 'POST', body: sessaoData });
export const updateSessao = (id, sessaoData) => request(`/sessoes/${id}`, { method: 'PUT', body: sessaoData });
export const deleteSessao = (id) => request(`/sessoes/${id}`, { method: 'DELETE' });

// --- Inscrições ---
export const getMinhasInscricoes = (participanteId) => request(`/inscricoes/participante/${participanteId}`);
export const criarInscricao = (eventoId) => request('/inscricoes', { method: 'POST', body: { eventoId } });
export const getDashboardStats = (participanteId) => request(`/inscricoes/dashboard/stats/${participanteId}`); // Stats para participante
export const getAdminDashboardStats = () => request('/admin/dashboard/stats'); // Novo endpoint para stats de admin
export const getInscricaoQrCode = (inscricaoId) => request(`/inscricoes/${inscricaoId}/qrcode`, { responseType: 'blob' });
export const getInscricaoByQrCode = (codigoQr) => request(`/inscricoes/detalhes-por-qrcode?codigoQr=${codigoQr}`);
export const getInscricaoByEmail = (email) => request(`/inscricoes/detalhes-por-email?email=${email}`); // REVERTIDO: Não inclui eventoId
export const getAdminInscricoes = (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    return request(`/inscricoes/admin/todas${queryParams ? `?${queryParams}` : ''}`);
};
export const updateInscricaoStatus = (inscricaoId, novoStatus) => request(`/inscricoes/${inscricaoId}/status`, { method: 'PUT', body: { novoStatus } });
// ATUALIZADO: Endpoint de quick checkin agora é público
export const quickSignupAndCheckin = (data) => request('/public/quick-signup-checkin', { method: 'POST', body: data });
// ATUALIZADO: Obter contexto do local da sessão usando o qrCodeKey (UUID)
export const getLocalSessaoContext = (qrCodeKey) => request(`/public/locais-sessao/contexto/${qrCodeKey}`);

export const confirmarPendentesEmMassa = (eventoId) => {
    const endpoint = `/admin/inscricoes/confirmar-pendentes${eventoId ? `?eventoId=${eventoId}` : ''}`;
    return request(endpoint, { method: 'PUT' });
};

// --- Presenças ---
export const getPresencasBySessao = (sessaoId) => request(`/presencas/sessao/${sessaoId}`); // CORRIGIDO: Usando template literal
export const registrarPresenca = (data) => request('/presencas/registrar', { method: 'POST', body: data });
// NOVO: Registrar presença em um LocalSessao específico
export const registrarPresencaLocal = (data) => request('/presencas/checkin/local', { method: 'POST', body: data });
export const getPresencasDetalhesBySessao = (sessaoId) => request(`/sessoes/${sessaoId}/presencas-detalhes`);
export const exportPresencasPdf = (sessaoId) => request(`/sessoes/${sessaoId}/export/pdf`, { responseType: 'blob' });
export const exportPresencasXlsx = (sessaoId) => request(`/sessoes/${sessaoId}/export/xlsx`, { responseType: 'blob' });
// CORRIGIDO: O payload deve usar 'qrCodeKey' para corresponder ao SelfCheckinRequest do backend
export const selfServiceCheckin = (qrCodeKey) => request('/presencas/self-checkin', { method: 'POST', body: { qrCodeKey } });

// --- Certificados ---
export const checkCertificadoElegibilidade = (inscricaoId) => request(`/certificados/elegivel/${inscricaoId}`);
export const downloadCertificado = (inscricaoId) => request(`/certificados/baixar/${inscricaoId}`, { responseType: 'blob' });

// --- Admin User Management ---
export const createAdminUser = (userData) => request('/admin/usuarios', { method: 'POST', body: userData }); // Novo endpoint para criar usuários admin
export const getAllUsers = (filters = {}) => { // NOVO: Listar todos os usuários
    const queryParams = new URLSearchParams(filters).toString();
    return request(`/admin/usuarios/all${queryParams ? `?${queryParams}` : ''}`); // ALTERADO AQUI
};
export const getUserDetails = (id) => request(`/admin/usuarios/${id}`); // NOVO: Obter detalhes de um usuário
export const updateUserDetails = (id, userData) => request(`/admin/usuarios/${id}`, { method: 'PUT', body: userData }); // NOVO: Atualizar dados do usuário
export const updateUserRole = (id, role) => request(`/admin/usuarios/${id}/role`, { method: 'PUT', body: { role } }); // NOVO: Atualizar papel do usuário
export const deleteUser = (id) => request(`/admin/usuarios/${id}`, { method: 'DELETE' }); // NOVO: Deletar usuário

// NOVO: Endpoints para LocalSessao
export const createLocalSessao = (sessaoId, localSessaoData) => request(`/admin/sessoes/${sessaoId}/locais`, { method: 'POST', body: localSessaoData });
export const getLocaisSessaoBySessao = (sessaoId) => request(`/admin/sessoes/${sessaoId}/locais`);
export const updateLocalSessao = (localId, localSessaoData) => request(`/admin/locais/${localId}`, { method: 'PUT', body: localSessaoData });
export const deleteLocalSessao = (localId) => request(`/admin/locais/${localId}`, { method: 'DELETE' });
export const getLocalSessaoQrCode = (localSessaoId, width = 1000, height = 1000) => 
    request(`/admin/qrcode/local-sessao/${localSessaoId}?width=${width}&height=${height}`, { responseType: 'blob' });

// NOVO ENDPOINT: Importar locais de sessão
export const importarLocaisSessao = (sessaoDestinoId, sessaoOrigemId) => 
    request(`/admin/sessoes/${sessaoDestinoId}/importar-locais`, { 
        method: 'POST', 
        body: { sessaoOrigemId } 
    });

// ENDPOINT DE SUPORTE SEM ANEXO (mantido por compatibilidade, mas não usado no novo fluxo)
export const sendSupportEmail = (data) => request('/suporte/email-participante', { method: 'POST', body: data });

// NOVO ENDPOINT DE SUPORTE COM ANEXO (usando FormData)
export const sendSupportEmailWithAttachment = (formData) => 
    request('/suporte/email-participante-anexo', { 
        method: 'POST', 
        body: formData, 
        isFormData: true 
    });